module.exports = __webpack_public_path__ + "static/standalone/img/buyer-insolvent.09531d38.svg";